import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

// components
import { Button, Error } from '../shared/_form';

const New1 = function(props) {
  const errors = props.errors;
  const form   = props.form;

  return (
    <div className='rep-new__signup__step1'>
      <h2 className='panel__heading'>
        Create an account with Open Books MD!
      </h2>
      <div className='form'>
        <form onSubmit={ props.onNextStep }>
          <input className='form__field form__field--rounded'
            name='email'
            onChange={ props.onFormChange }
            placeholder='Email address'
            type='email'
            value={ form.email || '' } />
          <Error className='form__error--rounded'>{ errors.get('user.email') }</Error>
          <input className='form__field form__field--rounded'
            name='password'
            onChange={ props.onFormChange }
            placeholder='Password'
            type='password'
            value={ form.password || '' } />
          <Error className='form__error--rounded'>{ errors.get('user.password') }</Error>
          <div className='form__submit'>
            <Button className='form__button form__button--green' loading={ props.loading }>Next</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

New1.defaultProps = {
  errors: Immutable.Map()
};

New1.propTypes = {
  errors:       PropTypes.instanceOf(Immutable.Map).isRequired,
  form:         PropTypes.instanceOf(Object).isRequired,
  loading:      PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  onNextStep:   PropTypes.func.isRequired
};

export default New1;



// WEBPACK FOOTER //
// ./app/components/reps/_New1.jsx